import type { TFunction } from 'i18next'

import { convertToStandardMarketProgramType } from './convertToStandardMarketProgramType'

/**
 * Translates a raw market program coming from the insights API (e.g. 'FCR_D_UP_DYNAMIC',
 * 'WHOLESALE_FEES') into its display label. Falls back to the raw value when the market
 * program is not known yet by the frontend, so new backend values degrade gracefully
 * instead of showing a translation key.
 */
export function getMarketProgramLabel(t: TFunction, rawMarketProgram: string): string {
  return t(`common.market_program.${convertToStandardMarketProgramType(rawMarketProgram)}`, {
    defaultValue: rawMarketProgram,
  })
}
